/* eslint-disable react-hooks/exhaustive-deps */

import { useCallback } from 'react';
import { useApiRequest } from './useApiRequest';

export default function useRequest() {
    const { makeRequest } = useApiRequest();

    return useCallback(
        async <R>({
            path,
            method = 'GET',
            params,
        }: {
            path: string;
            method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
            params?: Record<string, unknown>;
        }) => {
            return makeRequest<R>({ path, method, params });
        },
        [makeRequest],
    );
}
